import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CartService } from '@hdms/shared/data-access';
import { EnvironmentService } from '@hdms/shared/util-core';

import { CartPaymentEligibilityGqlService } from '../queries/checkout-payment-eligibility-gql.service';

interface CartVerificationResponse {
  result: string;
  error: string;
}
@Injectable({ providedIn: 'root' })
export class CartLegacyService {
  private readonly httpClient = inject(HttpClient);
  private readonly env = inject(EnvironmentService);
  private readonly cartService = inject(CartService);
  private readonly cartPaymentEligibilityGqlService = inject(CartPaymentEligibilityGqlService);

  verifyCartEligibilityForClickAndCollect(checkboxValue = false): Observable<CartVerificationResponse> {
    return this.httpClient.get<CartVerificationResponse>(
      `${this.env.dusBaseUrl}/cart/isGuestCheckoutEligible?clickAndCollectEnabled=${checkboxValue}`
    );
  }

  verifyCartPaymentEligibility(): Observable<boolean> {
    return this.cartPaymentEligibilityGqlService
      .fetch({ cartId: this.cartService.cartId })
      .pipe(map(response => response.data.isCartEligibleForCheckout));
  }
}
